<div class="example-container" [class.example-is-mobile]="mobileQuery.matches">
  <mat-toolbar class="example-toolbar">
    <button mat-icon-button (click)="snav.toggle()">
      <mat-icon>menu</mat-icon>
    </button>
    <div class="brand-icon">
      <img src="/assets/images/klusup.png" alt="Klusup" width="100">
    </div>
    {{currentNavName}}
  </mat-toolbar>

  <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav #snav [mode]="mobileQuery.matches ? 'over' : 'side'" [fixedInViewport]="mobileQuery.matches"
      [opened]="isSidenavOpen">
      <ul class="mcd-menu" aria-label="msc-menu">
        @for (nav of fillerNav; track nav) {
          <li>
            <a [routerLink]="['/components', nav.name]" routerLinkActive="active-link"
               [routerLinkActiveOptions]="{ exact: true }">
              <!-- Main Navigation Item -->
              <img [src]="'../../../assets/images/' + nav.icon" alt="{{nav.name}} icon" class="nav-icon">
              <strong>{{ nav.name }}</strong>
            </a>
          </li>
        }
      </ul>
    </mat-sidenav>
    <mat-sidenav-content>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>